import img1 from "../images/licens1.jpeg";
import img2 from "../images/licens2.jpeg";
import img3 from "../images/licens3.jpeg";
import img4 from "../images/licens4.jpeg";
import img5 from "../images/license5.jpeg";
import img6 from "../images/licens6.jpeg";
import img7 from "../images/licens7.jpeg";
import SectionHeading from "./ui/SectionHeading";
import Reveal from "./ui/Reveal";

const images = [img1, img2, img3, img4, img5, img6, img7];

const License = () => {
  return (
    <section id="license" className="section-pad bg-[#eef5ea]">
      <SectionHeading
        eyebrow="Trust & Credibility"
        title="Licenses & Certifications"
        subtitle="Government-licensed and fully certified — your journey is in safe, registered hands."
      />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {images.map((src, index) => (
          <Reveal key={index} delay={index * 0.05}>
            <div className="group overflow-hidden rounded-xl bg-white shadow-soft ring-1 ring-brand-gold/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-glow">
              <img
                src={src}
                alt={`License certificate ${index + 1}`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default License;
